"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function PlannedLocation() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="planned-location" ref={sectionRef} className="relative py-24 md:py-32 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <h2 className="text-4xl md:text-5xl font-display font-semibold tracking-tight text-foreground">
              Planned Location
            </h2>

            <div className="space-y-4">
              <p className="text-lg text-muted-foreground leading-relaxed">
                Prime Laundry is designed for development in{" "}
                <span className="relative inline-block font-medium text-foreground">
                  Spartanburg, South Carolina
                  <span className={`absolute bottom-0 left-0 h-px bg-accent transition-all duration-500 ease-out ${sectionVisible ? "w-full" : "w-0"}`} style={{
                  transitionDelay: "200ms"
                }} />
                </span>
                , a location selected for its demographic profile, market characteristics, and operational alignment with the concept's intended approach.
              </p>

              <p className="text-base text-muted-foreground leading-relaxed">
                Site selection criteria emphasize accessibility, visibility, population density, and competitive positioning. The location is anticipated to support efficient operations, predictable customer flow, and sustainable long-term performance.
              </p>
            </div>

            <div className="pt-4 space-y-3">
              <h3 className="text-sm font-medium tracking-wide uppercase text-muted-foreground">
                Key Selection Factors
              </h3>
              <ul className="space-y-2.5 text-base text-foreground">
                <li className="flex items-start gap-3">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
                  <span>Strategic demographic and economic profile</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
                  <span>High-visibility, accessible site placement</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
                  <span>Competitive market positioning opportunity</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent mt-2 shrink-0" />
                  <span>Infrastructure alignment with operational needs</span>
                </li>
              </ul>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <AspectRatio ratio={4 / 5} className="overflow-hidden rounded-md">
              <img src="https://primelaundrysc.com/wp-content/uploads/2026/02/Spartanburg-south-carolina-AdobeStock_255810035.webp" alt="Modern architectural detail featuring glass and steel textures" className="w-full h-full object-cover" />
            </AspectRatio>
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent rounded-md pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}